// import TrophyIconSrc from "@/assets/trophy.png";
import WarningIconSrc from "@/assets/warning.png";
import { useTranslation } from "react-i18next";

export function PlayerBanner() {
  const { t } = useTranslation(["profile"]);

  return (
    <div className="flex flex-col gap-2 rounded-xl bg-white p-4 shadow-sm sm:flex-row sm:items-center sm:gap-6 sm:p-6">
      <img src={WarningIconSrc} alt="trophé" className="hidden size-12 sm:block" />

      <div className="flex flex-col gap-2 sm:gap-1">
        <div className="flex items-center gap-2">
          <img src={WarningIconSrc} alt="trophé" className="size-10 sm:hidden" />
          <span className="text-lg font-semibold">
            {t("profile:banner.player-title")}
          </span>
        </div>

        <div className="text-sm text-neutral-500">
          {t("profile:banner.player-description")}

          <span className="block pt-1">
            {t("profile:banner.player-list-title")}
          </span>
          <ul className="pl-2 font-medium text-neutral-600">
            <li>
              &#8226;&nbsp;
              {t("profile:banner.player-list-one")}
            </li>
            <li>
              &#8226;&nbsp;
              {t("profile:banner.player-list-two")}
            </li>
            <li>
              &#8226;&nbsp;
              {t("profile:banner.player-list-three")}
            </li>
            <li>
              &#8226;&nbsp;
              {t("profile:banner.player-list-four")}
            </li>
            <li>
              &#8226;&nbsp;
              {t("profile:banner.player-list-five")}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
